module.exports = __webpack_public_path__ + "static/media/text-align-right.26920f36.svg";